import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import React from 'react';
import { useHistory } from 'react-router';

export const ErrorDialog = (props: any) => {
  const {
    errorDia,
    setErrorDia,
    errorMsg,
    errorHeaderMsg,
    isApprovalPolicy = false,
    onclick,
  } = props;
  const history = useHistory();

  const onDeniedPermission = (): void =>  {
    if(['permission', 'denied', 'authorized', 'access'].some((word) => errorMsg?.toLowerCase()?.includes(word))) {
      history.goBack()
    }
    setErrorDia(false)
  }

  return (
    <CommonDialog
      fullWidth={true}
      open={errorDia}
      onClose={() => {
        isApprovalPolicy ? onclick() : onDeniedPermission();
      }}
      sections={{
        header: {
          title: !!errorHeaderMsg
            ? `${errorHeaderMsg}
            ${errorHeaderMsg?.includes('Error!') ? '' : '!'}`
            : 'Error!',
          style: { color: 'red' },
        },
        body: () => (
          <div className="content-wrap full text-noflow">
            <div className="mdDesc text-noflow">{errorMsg}</div>
          </div>
        ),
        footer: {
          actions: [
            {
              displayText: 'Close',
              props: {
                onClick: () =>
                  isApprovalPolicy ? onclick() : onDeniedPermission(),
                variant: 'contained',
                color: 'primary',
              },
            },
          ],
        },
      }}
    />
  );
};
